<template>
  <div id="accountManagement">
    <div class="main">
      <div
        v-if="isContractAlertBannerShow"
        class="contract-expire-alert"
        :class="{ 'contract-expire-alert--clickable': audioContract.status === 3 }"
        @click="handleContractAlertBannerClick"
      >
        <span class="contract-expire-alert__icon"><img src="@/assets/img/intercom/caution.svg" alt="caution" /></span>
        <span class="contract-expire-alert__message">
          <template v-if="audioContract.status === 3">
            {{ $t('Intercom.ContractAlertMessage.expiring', { date: displayExpireDate }) }}
          </template>
          <template v-else>
            {{ $t('Intercom.ContractAlertMessage.expired', { date: displayExpireDate }) }}
          </template>
        </span>
      </div>
      <div class="title_bar">
        <div class="left">
          <div class="title">
            社區對講機
            <span
              class="introduction"
              @click="$toExternaLink('https://www.smartdaily.com.tw/smartintercom-guide/')"
            >{{ $t("General.Instructions") }}</span>
          </div>
          <div class="tip">
            {{ $t("Intercom.Tip") }}
          </div>
        </div>
      </div>
      <el-tabs
        id="feeTab"
        v-model="activeName"
        :before-leave="checkTab"
      >
        <el-tab-pane name="callRecordList">
          <span slot="label">通話紀錄</span>
        </el-tab-pane>
        <el-tab-pane name="sentryManagement">
          <span slot="label">{{ $t("Intercom.SentryManagementTab") }}</span>
        </el-tab-pane>
        <el-tab-pane name="residentOpen">
          <span slot="label">開通列表</span>
        </el-tab-pane>
      </el-tabs>
      <router-view ref="view" />
    </div>
    <AuthorizedDialog ref="authorizedDialog" />
    <ContractExpireDialog />
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import AuthorizedDialog from './components/AuthorizedDialog.vue'
import ContractExpireDialog from './components/ContractExpireDialog.vue'
export default {
  components: {
    AuthorizedDialog,
    ContractExpireDialog
  },
  data () {
    return {
      activeName: 'accountList',
      authorizedDialog: null // 使用授權名單 dialog 實體
    }
  },
  computed: {
    ...mapState({
      audioContract: (state) => state.intercom.audioContract,
      contractStats: (state) => state.intercom.contractStats,
      isContractAlertBannerShow: (state) => state.intercom.isContractAlertBannerShow
    }),
    ...mapGetters('intercom', ['displayExpireDate'])
  },
  created () {
    this.$store.dispatch('intercom/getContract', true) // 取得合約資料
    this.$store.commit('intercom/resetAudioContract') // 重置軟體語音合約狀態
  },
  mounted () {
    this.activeName = this.$route.name

    this.setContractDialogVisible(false) // 重置合約對話框顯示狀態
    this.setContractAlertBannerShow(false) // 重置合約橫幅顯示狀態

    // 取得合約相關資料
    Promise.all([
      this.$store.state.intercom.contractPromise,
      this.$store.dispatch('intercom/getAudioContract')
    ]).then(() => {
      this.checkAudioContractStatus()
      this.checkUnconfirmAuthorizedTablets()
    }).catch((error) => {
      console.error(error)
    })
  },
  methods: {
    ...mapMutations('intercom', [
      'setContractAlertBannerShow',
      'setContractDialogVisible'
    ]),
    checkTab (activeName, oldActiveName) {
      if (activeName !== oldActiveName) {
        this.$router.push({ name: activeName })
      }
    },
    // 檢查軟體語音合約狀態
    checkAudioContractStatus () {
      if (this.audioContract.status === 2) { // 是否合約已到期
        if (!this.audioContract.hasNextContract) { // 是否無續約
          this.setContractDialogVisible(true)
        }
      } else if (this.audioContract.status === 3) { // 是否合約即將到期(1個月內)，且無續約
        this.setContractAlertBannerShow(true)
      }
    },
    /**
     * 處理合約到期提醒橫幅點擊事件
     */
    handleContractAlertBannerClick () {
      if (this.audioContract.status === 3) { // 是否合約即將到期(1個月內)
        this.setContractDialogVisible(true)
      }
    },
    /**
     * 檢查是否有待確認的授權名單
     */
    async checkUnconfirmAuthorizedTablets () {
      try {
        const res = await apiIntercom.Sentry.GetUnconfirmAuthorizedTablets()
        const exists = res?.data?.Data?.Exists
        if (exists === true) {
          this.handleUnconfirmAuthorizedExists()
          return
        }
        this.$refs.authorizedDialog.checkAuthorizedTablets()
      } catch (err) {
        console.log(err)
        this.$refs.authorizedDialog.checkAuthorizedTablets()
      }
    },
    /**
     * 待確認授權名單存在時的處理流程
     */
    async handleUnconfirmAuthorizedExists () {
      const description = `<pre>${this.$t('Intercom.UnconfirmAuthorizedTablets.Description', { text: `<span style="font-weight: bold;">${this.$t('Intercom.UnconfirmAuthorizedTablets.AutoCreate')}</span>` })}</pre>`
      this.$alert(description, this.$t('Intercom.UnconfirmAuthorizedTablets.Title'), {
        confirmButtonText: this.$t('Intercom.UnconfirmAuthorizedTablets.Confirm'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
        showClose: false,
        closeOnClickModal: false,
        callback: async () => {
          // 確認授權名單
          try {
            await apiIntercom.Sentry.PutUnconfirmAuthorizedTablets()
          } catch (err) {
            console.log(err)
          }
          // 切換到開通列表頁籤
          this.activeName = 'residentOpen'
          // 開啟授權名單對話框
          this.$store.commit('intercom/triggerAuthorizedDialog', true)
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#accountManagement
  padding: 50px 0 10px
  height: 100%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .contract-expire-alert
      display: flex
      align-items: center
      background-color: $bgWarning
      padding: 16px
      border-radius: 8px
      margin-bottom: 15px
      &--clickable
        cursor: pointer
      &__icon
        width: 20px
        height: 20px
        margin-right: 8px
      &__message
        font-size: map-get($fontSize, medium)
        font-weight: 600
        color: $warnColor
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .introduction
        color: $mainColorDark
        font-size: 20px
        font-weight: initial
        margin: 0 10px
        text-decoration: underline
        cursor: pointer
        &:before
          content: '('
          color: #000
        &:after
          content: ')'
          color: #000
      .questionnaire
        background-color: $bgDark3
        padding: 5px 8px
        span
          color: $mainColor
          cursor: pointer
          margin: 0 10px 0 13px
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
        line-height: normal
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .title_bar.center
      margin: 20px 0 10px 0
#feeTab
  text-align: center
  ::v-deep .el-tabs
    +basicTabs
    &__header
      margin: 0 0 0
    &__item
      min-width: 130px
      height: 42px
      span
        width: 100%
        display: inline-block
</style>
